<template>
      <div class="pageParametersEdit">
        <v-breadcrumbs>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
            >Home</v-breadcrumbs-item
          >
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'pageParameters', params: {} }">
          Page Parameters
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :to="{ name: 'pageParametersEdit', params:{id: id} }">
            Edit Page Parameters
          </v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-card>
          <v-card-title>Edit Page Parameters</v-card-title>
          <v-card-text>
            <pageParameters-form :id="id"></pageParameters-form>
          </v-card-text>
        </v-card>
      </div>
    </template>

    <script>
    import PageParametersForm from './PageParametersForm.vue';

    export default {
      name: 'pageParameters',
      data () {
        return {
          id: null
        }
      },
      components: {
        PageParametersForm
      },
      created () {
          this.id = this.$route.params.id;
          this.$emit("showParent", false);
      }
    }
    </script>
    